import { SchedulerPreference, SchedulerPreferenceV3, TimeboxSessionType } from '@demind-inc/core';
import { SchedulerPrefDurationRange } from '../../..';

export interface TimeboxPrefItem {
  duration: SchedulerPrefDurationRange;
}

export type TimeboxPrefItemState = Record<TimeboxSessionType, TimeboxPrefItem>;

export const initialDefaultTimeboxPrefItemState: TimeboxPrefItemState = {
  deepWork: {
    duration: {
      durationMin: 4 * 60, // 4 hours
      minimumDurationMin: 0,
      maximumDurationMin: 9 * 60, // 9 hours
    },
  },
  lightWork: {
    duration: {
      durationMin: 90, // 1.5 hours
      minimumDurationMin: 0,
      maximumDurationMin: 9 * 60, // 9 hours
    },
  },
};

export const timeboxPrefItemReducer = (
  state: TimeboxPrefItemState,
  action: {
    type: TimeboxSessionType | 'initialize';
    payload: Partial<TimeboxPrefItemState[TimeboxSessionType] | TimeboxPrefItemState>;
  }
): TimeboxPrefItemState => {
  if (action.type === 'initialize') {
    return action.payload as TimeboxPrefItemState;
  }

  switch (action.type) {
    case 'deepWork':
      return {
        ...state,
        deepWork: {
          ...state.deepWork,
          ...action.payload,
        },
      };
    case 'lightWork':
      return {
        ...state,
        lightWork: {
          ...state.lightWork,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export const transformDBPrefToTimeboxPref = (pref: SchedulerPreference) => {
  return {
    deepWork: {
      ...initialDefaultTimeboxPrefItemState.deepWork,
      ...(pref.deepWork?.durationMin
        ? {
            duration: {
              ...initialDefaultTimeboxPrefItemState.deepWork.duration,
              durationMin: pref.deepWork.durationMin,
              defaultMin: pref.deepWork.durationMin,
            },
          }
        : {
            // Ensure we always have the complete structure even when API data is missing
            duration: {
              ...initialDefaultTimeboxPrefItemState.deepWork.duration,
            },
          }),
    },
    lightWork: {
      ...initialDefaultTimeboxPrefItemState.lightWork,
      ...(pref.lightWork?.durationMin
        ? {
            duration: {
              ...initialDefaultTimeboxPrefItemState.lightWork.duration,
              durationMin: pref.lightWork.durationMin,
              defaultMin: pref.lightWork.durationMin,
            },
          }
        : {
            // Ensure we always have the complete structure even when API data is missing
            duration: {
              ...initialDefaultTimeboxPrefItemState.lightWork.duration,
            },
          }),
    },
  };
};

export const transformTimeboxPrefToDB = (pref: TimeboxPrefItemState): SchedulerPreferenceV3 => {
  return {
    deepWork: {
      durationMin: pref.deepWork.duration.durationMin,
    },
    lightWork: {
      durationMin: pref.lightWork.duration.durationMin,
    },
  };
};
